import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Password reset link sent to ${email}`);
    navigate('/admin-login');
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        height: '100vh',
      }}
    >
      {/* Left Illustration Section */}
      <div
        style={{
          flex: '0 0 60%', // Set left section to 60%
          display: isMobile ? 'none' : 'block',
          backgroundImage: 'url("../images/studentloginimg.jpg")', // Updated image to match AdminLogin
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      {/* Right Form Section */}
      <div
        style={{
          flex: '0 0 40%', // Set right section to 40%
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: 'linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF)', // Applied gradient background
          padding: '10px', // Reduced padding from 40px to 10px
          overflowY: 'hidden', // Added to match AdminLogin
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '400px', // Matches AdminLogin
            backgroundColor: '#fff',
            padding: '20px', // Reduced padding from 40px to 20px
            borderRadius: '16px', // Adjusted borderRadius to match AdminLogin
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.08)', // Matches AdminLogin
            textAlign: 'center',
          }}
        >
          <h2 style={{ marginBottom: '16px', color: 'purple', fontSize: '24px' }}>
            Forgot Password
          </h2>

          <form
            onSubmit={handleSubmit}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              alignItems: 'center', // Center form elements to match AdminLogin
            }}
          >
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                padding: '10px 14px', // Adjusted padding to match AdminLogin
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
                maxWidth: '300px', // Added to match AdminLogin
                width: '100%', // Ensure it fits within maxWidth
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />

            <button
              type="submit"
              style={{
                padding: '10px 25px', // Adjusted padding to match AdminLogin
                backgroundImage:
                  'linear-gradient(#fff, #fff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF)', // Changed to gradient to match AdminLogin
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                color: 'purple', // Changed color to match AdminLogin
                fontWeight: 'bold', // Added to match AdminLogin
                fontSize: '14px', // Adjusted fontSize to match AdminLogin
                border: '2px solid transparent', // Added to match gradient border effect
                borderRadius: '30px', // Adjusted borderRadius to match AdminLogin
                cursor: 'pointer',
                transition: 'all 0.3s ease', // Updated transition to match AdminLogin
                marginTop: '12px', // Added to match AdminLogin
                maxWidth: '300px', // Added to match AdminLogin
                width: '45%', // Set width to match AdminLogin
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)', // Added to match AdminLogin
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'scale(1.03)';
                e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
              }}
            >
              Reset Password
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;